import { FormProps } from "../../../../../forms/@types/form";
import {
  AnalysisTypes,
  DynamicAnalysisKeys
} from "../../../../header/hooks/usePrepareReanalyzeData";

export type ExternalIntegrationType = Exclude<
  DynamicAnalysisKeys,
  "rl_auxiliary_analysis" | "rl_dynamic_analysis"
>;

export type RlcsParams = {
  platform?: string;
  geolocation?: string;
  locale?: string;
  internet_simulation?: boolean;
  execution_timeout?: number;
  sample_name?: string;
};

export type InteractiveParams = Pick<
  RlcsParams,
  "platform" | "execution_timeout" | "sample_name" | "geolocation" | "locale"
>;

type RlcsParamKeys = keyof RlcsParams;
type RlcsErrorKeys = RlcsParamKeys | "timeout" | "url" | "interactive_timeout";
export type RlcsErrors = Partial<Record<RlcsErrorKeys, string>>;

export type SourcesState = {
  sourceTag: string;
  fileOriginLink: string;
};

export type ReanalyzeFormProps = {
  onSubmit: () => void;
  onCancel: () => void;
  popupWindowData: AnalysisTypes;
  onRlcsParamsChange: (value: RlcsParams) => void;
  rlcsParams: RlcsParams;
  interactiveParams: InteractiveParams;
  onInteractiveParamChange: (value: InteractiveParams) => void;
  tcAnalysisDisabled: boolean;
  ticloudAnalysisDisabled: boolean;
  interactiveAnalysisDisabled: boolean;
  submitButtonLabel: string;
  onFilePasswordChange: (value: string) => void;
  showFilePasswordField: boolean;
  displayWarningMessage: boolean;
  isSubmitted: boolean;
  isLoading: boolean;
  showHint?: boolean;
  rlcsErrors: RlcsErrors;
  showLocalOnlyAnalysis?: boolean;
  modalLayout?: string;
  sources?: SourcesState;
  onSourcesChange?: (sources: SourcesState) => void;
  fileUrl?: string;
} & FormProps;
